import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-turns-reports-appcancelled-card',
  templateUrl: './turns-reports-appcancelled-card.component.html',
  styleUrls: ['./turns-reports-appcancelled-card.component.scss']
})
export class TurnsReportsAppcancelledCardComponent implements OnInit {

  @Input() value;

  constructor() { }

  ngOnInit() {
  }

}
